import logger from 'ws-scripts/modules/logger';

const LOG_PREFIX = '[ws-locations-search][geocoder]';

/**
 * Wait for Google Maps API to be available
 * @param {number} timeout - Maximum time to wait in milliseconds
 * @returns {Promise<boolean>} - True if Google Maps is available, false if timeout
 */
export const waitForGoogleMaps = (timeout = 10000) => {
	return new Promise((resolve) => {
		const startTime = Date.now();

		const checkGoogle = () => {
			if (
				window.google &&
				window.google.maps &&
				window.google.maps.Geocoder
			) {
				resolve(true);
				return;
			}

			if (Date.now() - startTime > timeout) {
				logger.warn(
					`${LOG_PREFIX} Timeout waiting for Google Maps API`
				);
				resolve(false);
				return;
			}

			setTimeout(checkGoogle, 100);
		};

		checkGoogle();
	});
};

/**
 * Geocode a single address using Google Maps Geocoding API
 * @param {string} address - Address string to geocode
 * @returns {Promise<Object|null>} - Coordinates object or null if failed
 */
export const geocodeSingleAddress = (address) => {
	return new Promise((resolve) => {
		if (
			!window.google ||
			!window.google.maps ||
			!window.google.maps.Geocoder
		) {
			logger.error(`${LOG_PREFIX} Google Maps API not available`);
			resolve(null);
			return;
		}

		const geocoder = new window.google.maps.Geocoder();

		geocoder.geocode({ address }, (results, status) => {
			if (status === 'OK' && results && results.length > 0) {
				const { location } = results[0].geometry;
				resolve({
					latitude: location.lat(),
					longitude: location.lng()
				});
			} else {
				logger.warn(
					`${LOG_PREFIX} Geocoding failed for "${address}". Status: ${status}`
				);
				resolve(null);
			}
		});
	});
};
